export { AccountTemplate, type AccountTemplateProps } from './AccountTemplate';
export {
  AccountRegisterTemplate,
  type AccountRegisterTemplateProps,
} from './AccountRegisterTemplate';
export {
  AccountMyPageTemplate,
  type AccountMyPageTemplateProps,
} from './AccountMyPageTemplate';
export {
  AccountTwoColumnTemplate,
  type AccountTwoColumnTemplateProps,
} from './AccountTwoColumnTemplate';
